export default __webpack_public_path__ + "static/media/8.2bd5c8c2.png";